/** Show a toast notification (replaces alert). */
export function showMsg(msg: string, type?: string) {
  // Remove existing toast if present
  const existing = document.getElementById('t82-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 't82-toast';
  toast.className = 't82-toast' + (type ? ' t82-toast--' + type : '');
  toast.textContent = msg;
  document.body.appendChild(toast);

  // Trigger reflow then animate in
  toast.offsetHeight;
  toast.classList.add('t82-toast--visible');

  setTimeout(() => {
    toast.classList.remove('t82-toast--visible');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}
